/*
 *
 *  sagas
 *
 */

import { call, take, put, race, all } from "redux-saga/effects"

import {
  LOAD_RECORDS_META_DATA,
  CREATE_QUOTATION_RECORD,
  DELETE_QUOTATION_RECORD,
  UPDATE_QUOTATION_RECORD,
  CREATE_DELIVERABLE,
  DELETE_DELIVERABLE,
  UPDATE_DELIVERABLE,
  LOAD_RECORD_QUOTATION_DETAILS,
  LOAD_DELIVERABLE_DETAILS,
  CREATE_INSTRUCTIONS,
  UPDATE_INSTRUCTIONS,
  DELETE_INSTRUCTIONS,
  LOAD_INSTRUCTIONS,
  LOAD_PHOTOGRAPHY,
  CREATE_PHOTOGRAPHY,
  UPDATE_PHOTOGRAPHY,
  DELETE_PHOTOGRAPHY,
  LOAD_SERVICE_DETAILS,
  LOAD_SERVICE_ACCOUNT,
  APPROVE_QC_REQUEST,
  LOAD_QUOTATION_HISTORY_DETAILS,
  LOAD_SALES_APPROVAL,
  LOAD_EMPLOYEE,
  LOAD_QC_HISTORY,
  UPDATE_QC_REAPPROVE,
  UPDATE_QUOTATION_LIST,
  LOAD_QUOTATION_LIST,
  LOAD_QC_LAYOUT_MASTER,
  LOAD_QC_LAYOUT_SEGMENT,
  LOAD_QUOTATION_PREVIEW,
  LOAD_VALUE_INSERT,
  CREATE_VALUE_INSERT,
  UPDATE_VALUE_INSERT,
  DELETE_VALUE_INSERT,
  UPDATE_EXPIRY_DATE,
  UPDATE_QUOTATION_PREVIEW,
  ADD_SEGMENT_PREVIEW,
  ADD_PRODUCT_ASSIGN,
  ADD_TEAM_ASSIGN,
  UPDATE_CRM_DELIVER,
  LOAD_EC_DELIVERABLE_DETAILS,
  LOAD_DELIVERABLE_EMPLOYEE,
  UPDATE_DISCOUNT_PREVIEW,
  UPDATE_PROCESS,
  ADD_CRM,
  LOAD_PROCESS_STATUS,
  LOAD_DELIVERABLES_RECORDS_META_DATA,
  LOAD_INSTRUCTIONS_RECORDS_META_DATA,
} from "./constants"

import {
  loadRecordsMetaDataSuccess,
  loadRecordsMetaDataError,
  loadRecordQuotationDetails as loadRecordQuotationDetailsAction,
  loadRecordQuotationDetailsSuccess,
  loadRecordQuotationDetailsError,
  createQuotationRecordError,
  createQuotationRecordSuccess,
  deleteQuotationRecordError,
  deleteQuotationRecordSuccess,
  updateQuotationRecordError,
  updateQuotationRecordSuccess,
  loadDeliverableDetails as loadDeliverableDetailsAction,
  loadDeliverableDetailsSuccess,
  loadDeliverableDetailsError,
  createDeliverableError,
  createDeliverableSuccess,
  deleteDeliverableError,
  deleteDeliverableSuccess,
  updateDeliverableError,
  updateDeliverableSuccess,
  createInstructionSuccess,
  createInstructionError,
  updateInstructionSuccess,
  updateInstructionError,
  deleteInstructionSuccess,
  deleteInstructionError,
  loadInstructions as loadInstructionsAction,
  loadInstructionsSuccess,
  loadInstructionsError,
  loadPhotography as loadPhotographyAction,
  loadPhotographySuccess,
  loadPhotographyError,
  createPhotographySuccess,
  createPhotographyError,
  updatePhotographySuccess,
  updatePhotographyError,
  deletePhotographySuccess,
  deletePhotographyError,
  loadService as loadServiceDetailsAction,
  loadServiceTotal as loadServiceTotalAction,
  loadServiceSuccess,
  loadServiceError,
  loadServiceTotalSuccess,
  loadServiceTotalError,
  approvalRequestQcSuccess,
  approvalRequestQcError,
  loadQuotationHistoryDetailsSuccess,
  loadQuotationHistoryDetailsError,
  loadSalesApproval as loadSalesApprovalAction,
  loadQuotationList as loadQuotationListAction,
  loadSalesApprovalSuccess,
  loadSalesApprovalError,
  loadEmployee,
  loadEmployeeSuccess,
  loadEmployeeError,
  loadQcHistorySuccess,
  loadQcHistoryError,
  updateQcReapproveSuccess,
  updateQcReapproveError,
  loadQcHistory,
  updateQuotationListSuccess,
  updateQuotationListError,
  loadQuotationListSuccess,
  loadQuotationListError,
  loadQCLayoutMaster as loadQCLayoutMasterAction,
  loadQCLayoutMasterSuccess,
  loadQCLayoutMasterError,
  loadQCLayoutSegment as loadQCLayoutSegmentAction,
  loadQCLayoutSegmentSuccess,
  loadQCLayoutSegmentError,
  loadQuotationPreview,
  loadQuotationPreviewSuccess,
  loadQuotationPreviewError,
  loadValueInsert,
  loadValueInsertSuccess,
  loadValueInsertError,
  createValueInsertSuccess,
  createValueInsertError,
  updateValueInsertSuccess,
  updateValueInsertError,
  deleteValueInsertSuccess,
  deleteValueInsertError,
  updateExpiryDateSuccess,
  updateExpiryDateError,
  updateQuotationPreviewSuccess,
  updateQuotationPreviewError,
  addSegmentPreviewSuccess,
  addSegmentPreviewError,
  addProductAssignSuccess,
  addProductAssignError,
  addTeamAssignSuccess,
  addTeamAssignError,
  updateCrmDeliverError,
  updateCrmDeliverSuccess,
  loadECDeliverableDetails,
  loadECDeliverableDetailsSuccess,
  loadECDeliverableDetailsError,
  loadDeliverableEmployee,
  loadDeliverableEmployeeSuccess,
  loadDeliverableEmployeeError,
  updateDiscountPreviewSuccess,
  updateDiscountPreviewError,
  updateProcessSuccess,
  updateProcessError,
  addCrmAssignError,
  addCrmAssignSuccess,
  loadProcessStatus,
  loadProcessStatusSuccess,
  loadProcessStatusError,
  loadDeliverableRecordsMetaDataSuccess,
  loadDeliverableRecordsMetaDataError,
  loadInstructionsRecordsMetaDataSuccess,
  loadInstructionsRecordsMetaDataError,
} from "./actions"

import {
  loadRecordsMetaData,
  loadRecordQuotationDetails,
  createQuotationRecord,
  deleteQuotationRecord,
  updateQuotationRecord,
  loadDeliverableDetails,
  createDeliverable,
  deleteDeliverable,
  updateDeliverable,
  createInstruction,
  updateInstruction,
  deleteInstruction,
  loadInstructions,
  loadPhotography,
  createPhotography,
  deletePhotography,
  updatePhotography,
  loadServiceDetails,
  loadServiceTotal,
  loadSalesApproval,
  approvalRequestQc,
  loadQuotationHistoryDetails,
  loadEmployeeList,
  loadQcHistoryDetails,
  updateReapproveQc,
  updateQuotationList,
  loadQuotationList,
  loadQCLayoutMaster,
  loadQCLayoutSegment,
  loadQuotationPreviewDetails,
  loadValueInsertDetails,
  createValueInsertDetails,
  updateValueInsertDetails,
  deleteValueInsertDetails,
  updateExpiryDateDetails,
  updateQuotationPreviewDetails,
  addSegmentPreviewDetails,
  addProductAPI,
  addTeamAPI,
  updateCrmDeliverAPI,
  loadDeliverableECDetailsData,
  loadDeliverableEmployeeList,
  updateDiscountPreviewDetails,
  updateProcessAPI,
  addCrmAssignApi,
  loadProcessStatusApi,
  loadDeliverableRecordsMetaDataDetails,
  loadInstructionsRecordsMetaDataDetails,
} from "./remotes"

function* loadRecordQuotationDetailsSaga() {
  while (true) {
    // eslint-disable-line no-constant-condition
    const load = yield race({
      explicitLoad: take(LOAD_RECORD_QUOTATION_DETAILS),
    })

    const { explicitLoad } = load

    const { id } = explicitLoad || {}
    yield put(loadRecordQuotationDetailsAction(explicitLoad.id)) // Calling Dropdown API's

    if (explicitLoad) {
      try {
        const result = yield call(loadRecordQuotationDetails, id)

        if (result) {
          yield put(loadRecordQuotationDetailsSuccess(result.data))
        } else {
          yield put(loadRecordQuotationDetailsError("Fetch Records Failed"))
        }
      } catch (error) {
        yield put(
          loadRecordQuotationDetailsError(
            (error && error.response && error.response.message) ||
              "Fetch Records Failed"
          )
        )
      }
    }
  }
}

function* createQuotationRecordSaga() {
  while (true) {
    // eslint-disable-line no-constant-condition
    const { create } = yield race({
      create: take(CREATE_QUOTATION_RECORD),
    })
    const { quotationData, record, setSubmitting } = create || {}
    console.log("records-create", quotationData, setSubmitting)
    if (create) {
      console.log("records", quotationData)

      // yield call(setSubmitting, true)
      try {
        console.log("create records")
        yield call(createQuotationRecord, quotationData, record)

        console.log("create records", quotationData)
        // yield delay(1000)

        var successVal = createQuotationRecordSuccess(
          quotationData,
          [],
          "Record Created Successfully"
        )

        yield put(successVal)
        // yield put(loadRecordquotationDetailsAction(quotationData._id))
        // yield call(redirect)
      } catch (error) {
        yield put(
          createQuotationRecordError(
            (error && error.response && error.response.message) ||
              "Create Record Failed"
          )
        )
      } finally {
        // yield call(setSubmitting, false)
      }
    }
  }
}

function* editQuotationRecordSaga() {
  while (true) {
    // eslint-disable-line no-constant-condition
    const { edit } = yield race({
      edit: take(UPDATE_QUOTATION_RECORD),
    })

    console.log("FFFF &&& Lokesh Func ->", edit)

    const { quotationData, record } = edit || {}
    if (edit) {
      // yield call(setSubmitting, true)

      try {
        yield call(updateQuotationRecord, quotationData)
        // yield delay(1000)
        yield put(
          updateQuotationRecordSuccess(
            quotationData,
            record,
            "Record Updated Successfully"
          )
        )
        // yield call(redirect)
      } catch (error) {
        yield put(
          updateQuotationRecordError(
            (error && error.response && error.response.message) ||
              "Update Record Failed"
          )
        )
      } finally {
        // yield call(setSubmitting, false)
      }
    }
  }
}

function* deleteQuotationRecordSaga() {
  while (true) {
    // eslint-disable-line no-constant-condition
    const { del } = yield race({
      del: take(DELETE_QUOTATION_RECORD),
    })
    const { quotationLeadId, quotationRemoveId } = del || {}
    if (del) {
      // yield call(setSubmitting, true)

      try {
        yield call(deleteQuotationRecord, quotationLeadId, quotationRemoveId)
        // yield delay(1000)
        console.log(quotationLeadId, quotationRemoveId, "saga for delete event")

        yield put(
          deleteQuotationRecordSuccess(
            quotationLeadId,
            quotationRemoveId,
            "Record Deleted Successfully"
          )
        )
        // yield call(redirect)
      } catch (error) {
        yield put(
          deleteQuotationRecordError(
            (error && error.response && error.response.message) ||
              "Delete Record Failed"
          )
        )
      } finally {
        // yield call(setSubmitting, false)
      }
    }
  }
}

// Deliverables section Saga

function* loadDeliverableDetailsSaga() {
  while (true) {
    // eslint-disable-line no-constant-condition
    const load = yield race({
      explicitLoad: take(LOAD_DELIVERABLE_DETAILS),
    })

    const { explicitLoad } = load

    const { id } = explicitLoad || {}
    yield put(loadDeliverableDetailsAction(explicitLoad.id)) // Calling Dropdown API's

    if (explicitLoad) {
      try {
        const result = yield call(loadDeliverableDetails, id)

        if (result) {
          yield put(loadDeliverableDetailsSuccess(result.data))
        } else {
          yield put(loadDeliverableDetailsError("Fetch Records Failed"))
        }
      } catch (error) {
        yield put(
          loadDeliverableDetailsError(
            (error && error.response && error.response.message) ||
              "Fetch Records Failed"
          )
        )
      }
    }
  }
}
function* loadECDeliverableDetailsSaga() {
  while (true) {
    // eslint-disable-line no-constant-condition
    const load = yield race({
      explicitLoad: take(LOAD_EC_DELIVERABLE_DETAILS),
    })

    const { explicitLoad } = load

    const { id } = explicitLoad || {}
    yield put(loadECDeliverableDetails(explicitLoad.id)) // Calling Dropdown API's

    if (explicitLoad) {
      try {
        const result = yield call(loadDeliverableECDetailsData, id)

        if (result) {
          yield put(loadECDeliverableDetailsSuccess(result.data))
        } else {
          yield put(loadECDeliverableDetailsError("Fetch Records Failed"))
        }
      } catch (error) {
        yield put(
          loadECDeliverableDetailsError(
            (error && error.response && error.response.message) ||
              "Fetch Records Failed"
          )
        )
      }
    }
  }
}

function* createDeliverableSaga() {
  while (true) {
    // eslint-disable-line no-constant-condition
    const { create } = yield race({
      create: take(CREATE_DELIVERABLE),
    })
    const { deliverData, record, setSubmitting } = create || {}
    console.log("records-create", deliverData, setSubmitting)
    if (create) {
      console.log("records", deliverData)

      // yield call(setSubmitting, true)
      try {
        console.log("create records")
        yield call(createDeliverable, deliverData, record)

        console.log("create records", deliverData)
        // yield delay(1000)

        var successVal = createDeliverableSuccess(
          deliverData,
          [],
          "Record Created Successfully"
        )

        yield put(successVal)
        // yield put(loadRecordquotationDetailsAction(deliverData._id))
        // yield call(redirect)
      } catch (error) {
        yield put(
          createDeliverableError(
            (error && error.response && error.response.message) ||
              "Create Record Failed"
          )
        )
      } finally {
        // yield call(setSubmitting, false)
      }
    }
  }
}

function* editDeliverableSaga() {
  while (true) {
    // eslint-disable-line no-constant-condition
    const { edit } = yield race({
      edit: take(UPDATE_DELIVERABLE),
    })

    console.log("FFFF &&& Lokesh Func ->", edit)

    const { deliverData, record } = edit || {}
    if (edit) {
      // yield call(setSubmitting, true)

      try {
        yield call(updateDeliverable, deliverData)
        // yield delay(1000)
        yield put(
          updateDeliverableSuccess(
            deliverData,
            record,
            "Record Updated Successfully"
          )
        )
        // yield call(redirect)
      } catch (error) {
        yield put(
          updateDeliverableError(
            (error && error.response && error.response.message) ||
              "Update Record Failed"
          )
        )
      } finally {
        // yield call(setSubmitting, false)
      }
    }
  }
}

function* deleteDeliverableSaga() {
  while (true) {
    // eslint-disable-line no-constant-condition
    const { del } = yield race({
      del: take(DELETE_DELIVERABLE),
    })
    const { deliverableLeadId, deliverableRemoveId } = del || {}
    if (del) {
      // yield call(setSubmitting, true)

      try {
        yield call(deleteDeliverable, deliverableLeadId, deliverableRemoveId)
        yield put(
          deleteDeliverableSuccess(
            deliverableLeadId,
            deliverableRemoveId,
            "Record Deleted Successfully"
          )
        )
      } catch (error) {
        yield put(
          deleteDeliverableError(
            (error && error.response && error.response.message) ||
              "Delete Record Failed"
          )
        )
      } finally {
        // yield call(setSubmitting, false)
      }
    }
  }
}

//Total service account

function* loadServiceAccountSaga() {
  while (true) {
    // eslint-disable-line no-constant-condition
    const load = yield race({
      explicitLoad: take(LOAD_SERVICE_ACCOUNT),
    })

    const { explicitLoad } = load

    const { id } = explicitLoad || {}
    yield put(loadServiceTotalAction(explicitLoad.id)) // Calling Dropdown API's

    if (explicitLoad) {
      try {
        const result = yield call(loadServiceTotal, id)

        if (result) {
          yield put(loadServiceTotalSuccess(result.data))
        } else {
          yield put(loadServiceTotalError("Fetch Records Failed"))
        }
      } catch (error) {
        yield put(
          loadServiceTotalError(
            (error && error.response && error.response.message) ||
              "Fetch Records Failed"
          )
        )
      }
    }
  }
}

//Expiry Details

function* updateExpiryDateSaga() {
  while (true) {
    // eslint-disable-line no-constant-condition
    const { create } = yield race({
      create: take(UPDATE_EXPIRY_DATE),
    })
    const { expiryDate } = create || {}

    if (create) {
      console.log("records", expiryDate)
      try {
        yield call(updateExpiryDateDetails, expiryDate)

        var successVal = updateExpiryDateSuccess(
          expiryDate,
          "Record Created Successfully"
        )

        yield put(successVal)
      } catch (error) {
        yield put(
          updateExpiryDateError(
            (error && error.response && error.response.message) ||
              "Create Record Failed"
          )
        )
      } finally {
        // yield call(setSubmitting, false)
      }
    }
  }
}

//Value Insert
function* loadValueInsertSaga() {
  while (true) {
    // eslint-disable-line no-constant-condition
    const load = yield race({
      explicitLoad: take(LOAD_VALUE_INSERT),
    })

    const { explicitLoad } = load

    const { id } = explicitLoad || {}
    yield put(loadValueInsert(explicitLoad.id)) // Calling Dropdown API's

    if (explicitLoad) {
      try {
        const result = yield call(loadValueInsertDetails, id)

        if (result) {
          yield put(loadValueInsertSuccess(result.data))
        } else {
          yield put(loadValueInsertError("Fetch Records Failed"))
        }
      } catch (error) {
        yield put(
          loadValueInsertError(
            (error && error.response && error.response.message) ||
              "Fetch Records Failed"
          )
        )
      }
    }
  }
}

function* createValueInsertaga() {
  while (true) {
    // eslint-disable-line no-constant-condition
    const { create } = yield race({
      create: take(CREATE_VALUE_INSERT),
    })
    const { valueInsert } = create || {}

    if (create) {
      console.log("records", valueInsert)
      try {
        yield call(createValueInsertDetails, valueInsert)

        var successVal = createValueInsertSuccess(
          valueInsert,
          "Record Created Successfully"
        )

        yield put(successVal)
      } catch (error) {
        yield put(
          createValueInsertError(
            (error && error.response && error.response.message) ||
              "Create Record Failed"
          )
        )
      } finally {
        // yield call(setSubmitting, false)
      }
    }
  }
}

function* editValueInsertSaga() {
  while (true) {
    // eslint-disable-line no-constant-condition
    const { edit } = yield race({
      edit: take(UPDATE_VALUE_INSERT),
    })

    console.log("FFFF &&& Lokesh Func ->", edit)

    const { valueInsert, record } = edit || {}
    if (edit) {
      try {
        yield call(updateValueInsertDetails, valueInsert)
        // yield delay(1000)
        yield put(
          updateValueInsertSuccess(
            valueInsert,
            record,
            "Record Updated Successfully"
          )
        )
        // yield call(redirect)
      } catch (error) {
        yield put(
          updateValueInsertError(
            (error && error.response && error.response.message) ||
              "Update Record Failed"
          )
        )
      } finally {
        // yield call(setSubmitting, false)
      }
    }
  }
}

function* deleteValueInsertSaga() {
  while (true) {
    // eslint-disable-line no-constant-condition
    const { del } = yield race({
      del: take(DELETE_VALUE_INSERT),
    })
    const { valueInsert } = del || {}
    if (del) {
      try {
        yield call(deleteValueInsertDetails, valueInsert)
        // yield delay(1000)
        yield put(
          deleteValueInsertSuccess(valueInsert, "Record Deleted Successfully")
        )
        // yield call(redirect)
      } catch (error) {
        yield put(
          deleteValueInsertError(
            (error && error.response && error.response.message) ||
              "Delete Record Failed"
          )
        )
      } finally {
        // yield call(setSubmitting, false)
      }
    }
  }
}

//Special Instructions
function* loadInstructionsSaga() {
  while (true) {
    // eslint-disable-line no-constant-condition
    const load = yield race({
      explicitLoad: take(LOAD_INSTRUCTIONS),
    })

    const { explicitLoad } = load

    const { id } = explicitLoad || {}
    yield put(loadInstructionsAction(explicitLoad.id)) // Calling Dropdown API's

    if (explicitLoad) {
      try {
        const result = yield call(loadInstructions, id)

        if (result) {
          yield put(loadInstructionsSuccess(result.data))
        } else {
          yield put(loadInstructionsError("Fetch Records Failed"))
        }
      } catch (error) {
        yield put(
          loadInstructionsError(
            (error && error.response && error.response.message) ||
              "Fetch Records Failed"
          )
        )
      }
    }
  }
}

function* createInstructionSaga() {
  while (true) {
    // eslint-disable-line no-constant-condition
    const { create } = yield race({
      create: take(CREATE_INSTRUCTIONS),
    })
    const { specialInstructions } = create || {}

    if (create) {
      console.log("records", specialInstructions)
      try {
        yield call(createInstruction, specialInstructions)

        var successVal = createInstructionSuccess(
          specialInstructions,
          "Record Created Successfully"
        )

        yield put(successVal)
      } catch (error) {
        yield put(
          createInstructionError(
            (error && error.response && error.response.message) ||
              "Create Record Failed"
          )
        )
      } finally {
        // yield call(setSubmitting, false)
      }
    }
  }
}

function* editInstructionsSaga() {
  while (true) {
    // eslint-disable-line no-constant-condition
    const { edit } = yield race({
      edit: take(UPDATE_INSTRUCTIONS),
    })

    console.log("FFFF &&& Lokesh Func ->", edit)

    const { specialInstructions, record } = edit || {}
    if (edit) {
      try {
        yield call(updateInstruction, specialInstructions)
        // yield delay(1000)
        yield put(
          updateInstructionSuccess(
            specialInstructions,
            record,
            "Record Updated Successfully"
          )
        )
        // yield call(redirect)
      } catch (error) {
        yield put(
          updateInstructionError(
            (error && error.response && error.response.message) ||
              "Update Record Failed"
          )
        )
      } finally {
        // yield call(setSubmitting, false)
      }
    }
  }
}

function* deleteInstructionsSaga() {
  while (true) {
    // eslint-disable-line no-constant-condition
    const { del } = yield race({
      del: take(DELETE_INSTRUCTIONS),
    })
    const { leadId, instructionsId } = del || {}
    if (del) {
      try {
        yield call(deleteInstruction, leadId, instructionsId)
        // yield delay(1000)
        yield put(
          deleteInstructionSuccess(
            leadId,
            instructionsId,
            "Record Deleted Successfully"
          )
        )
        // yield call(redirect)
      } catch (error) {
        yield put(
          deleteInstructionError(
            (error && error.response && error.response.message) ||
              "Delete Record Failed"
          )
        )
      } finally {
        // yield call(setSubmitting, false)
      }
    }
  }
}

//Photography event checklist

//Special Instructions
function* loadPhotographySaga() {
  while (true) {
    // eslint-disable-line no-constant-condition
    const load = yield race({
      explicitLoad: take(LOAD_PHOTOGRAPHY),
    })

    const { explicitLoad } = load

    const { id } = explicitLoad || {}
    yield put(loadPhotographyAction(explicitLoad.id)) // Calling Dropdown API's

    if (explicitLoad) {
      try {
        const result = yield call(loadPhotography, id)

        if (result) {
          yield put(loadPhotographySuccess(result.data))
        } else {
          yield put(loadPhotographyError("Fetch Records Failed"))
        }
      } catch (error) {
        yield put(
          loadPhotographyError(
            (error && error.response && error.response.message) ||
              "Fetch Records Failed"
          )
        )
      }
    }
  }
}

function* createPhotographySaga() {
  while (true) {
    // eslint-disable-line no-constant-condition
    const { create } = yield race({
      create: take(CREATE_PHOTOGRAPHY),
    })
    const { checklist } = create || {}

    if (create) {
      console.log("records", checklist)
      try {
        yield call(createPhotography, checklist)

        var successVal = createPhotographySuccess(
          checklist,
          "Record Created Successfully"
        )

        yield put(successVal)
      } catch (error) {
        yield put(
          createPhotographyError(
            (error && error.response && error.response.message) ||
              "Create Record Failed"
          )
        )
      } finally {
        // yield call(setSubmitting, false)
      }
    }
  }
}

function* editPhotographySaga() {
  while (true) {
    // eslint-disable-line no-constant-condition
    const { edit } = yield race({
      edit: take(UPDATE_PHOTOGRAPHY),
    })

    console.log("FFFF &&& Lokesh Func ->", edit)

    const { checklist } = edit || {}
    if (edit) {
      try {
        yield call(updatePhotography, checklist)
        // yield delay(1000)
        yield put(
          updatePhotographySuccess(checklist, "Record Updated Successfully")
        )
        // yield call(redirect)
      } catch (error) {
        yield put(
          updatePhotographyError(
            (error && error.response && error.response.message) ||
              "Update Record Failed"
          )
        )
      } finally {
        // yield call(setSubmitting, false)
      }
    }
  }
}

function* deletePhotographySaga() {
  while (true) {
    // eslint-disable-line no-constant-condition
    const { del } = yield race({
      del: take(DELETE_PHOTOGRAPHY),
    })
    const { leadId, eventCheckListId } = del || {}
    if (del) {
      try {
        yield call(deletePhotography, leadId, eventCheckListId)
        // yield delay(1000)
        yield put(
          deletePhotographySuccess(
            leadId,
            eventCheckListId,
            "Record Deleted Successfully"
          )
        )
        // yield call(redirect)
      } catch (error) {
        yield put(
          deletePhotographyError(
            (error && error.response && error.response.message) ||
              "Delete Record Failed"
          )
        )
      } finally {
        // yield call(setSubmitting, false)
      }
    }
  }
}

// Service section Saga

function* loadServiceDetailsSaga() {
  while (true) {
    // eslint-disable-line no-constant-condition
    const load = yield race({
      explicitLoad: take(LOAD_SERVICE_DETAILS),
    })

    const { explicitLoad } = load

    const { searchFilter } = explicitLoad || {}
    yield put(loadServiceDetailsAction(explicitLoad)) // Calling Dropdown API's

    if (explicitLoad) {
      try {
        const result = yield call(loadServiceDetails, searchFilter)

        if (result) {
          yield put(loadServiceSuccess(result.data))
        } else {
          yield put(loadServiceSuccess([]))
          yield put(loadServiceError("Fetch Records Failed"))
        }
      } catch (error) {
        yield put(loadServiceSuccess([]))
        yield put(
          loadServiceError(
            (error && error.response && error.response.message) ||
              "Fetch Records Failed"
          )
        )
      }
    }
  }
}

// Sales approval Saga

function* loadSalesApprovalSaga() {
  while (true) {
    // eslint-disable-line no-constant-condition
    const load = yield race({
      explicitLoad: take(LOAD_SALES_APPROVAL),
    })

    const { explicitLoad } = load

    // const { id } = explicitLoad || {}
    yield put(loadSalesApprovalAction(explicitLoad)) // Calling Dropdown API's

    if (explicitLoad) {
      try {
        const result = yield call(loadSalesApproval)

        if (result) {
          yield put(loadSalesApprovalSuccess(result.data))
        } else {
          yield put(loadSalesApprovalError("Fetch Records Failed"))
        }
      } catch (error) {
        yield put(
          loadSalesApprovalError(
            (error && error.response && error.response.message) ||
              "Fetch Records Failed"
          )
        )
      }
    }
  }
}

// Employee filter Saga

function* loadEmployeeSaga() {
  while (true) {
    // eslint-disable-line no-constant-condition
    const load = yield race({
      explicitLoad: take(LOAD_EMPLOYEE),
    })

    const { explicitLoad } = load

    // const { id } = explicitLoad || {}
    yield put(loadEmployee(explicitLoad)) // Calling Dropdown API's

    if (explicitLoad) {
      try {
        const result = yield call(loadEmployeeList)

        if (result) {
          yield put(loadEmployeeSuccess(result.data))
        } else {
          yield put(loadEmployeeError("Fetch Records Failed"))
        }
      } catch (error) {
        yield put(
          loadEmployeeError(
            (error && error.response && error.response.message) ||
              "Fetch Records Failed"
          )
        )
      }
    }
  }
}

// Qc history Saga

function* loadQcHistorySaga() {
  while (true) {
    // eslint-disable-line no-constant-condition
    const load = yield race({
      explicitLoad: take(LOAD_QC_HISTORY),
    })

    const { explicitLoad } = load

    const { id } = explicitLoad || {}
    yield put(loadQcHistory(explicitLoad.id)) // Calling Dropdown API's

    if (explicitLoad) {
      try {
        const result = yield call(loadQcHistoryDetails, id)

        if (result) {
          yield put(loadQcHistorySuccess(result.data))
        } else {
          yield put(loadQcHistoryError("Fetch Records Failed"))
        }
      } catch (error) {
        yield put(
          loadQcHistoryError(
            (error && error.response && error.response.message) ||
              "Fetch Records Failed"
          )
        )
      }
    }
  }
}

//Qc approval request

function* approvalRequestSaga() {
  while (true) {
    // eslint-disable-line no-constant-condition
    const { approve } = yield race({
      approve: take(APPROVE_QC_REQUEST),
    })
    const { leadId, leadQuotationId } = approve || {}
    if (approve) {
      try {
        yield call(approvalRequestQc, leadId, leadQuotationId)
        // yield delay(1000)
        yield put(
          approvalRequestQcSuccess(
            leadId,
            leadQuotationId,
            "Record Deleted Successfully"
          )
        )
        // yield call(redirect)
      } catch (error) {
        yield put(
          approvalRequestQcError(
            (error && error.response && error.response.message) ||
              "Delete Record Failed"
          )
        )
      } finally {
        // yield call(setSubmitting, false)
      }
    }
  }
}

//Qc Re approval request

function* updateReapprovalQcSaga() {
  while (true) {
    // eslint-disable-line no-constant-condition
    const { approve } = yield race({
      approve: take(UPDATE_QC_REAPPROVE),
    })
    const { qcRequestData } = approve || {}
    if (approve) {
      try {
        yield call(updateReapproveQc, qcRequestData)
        // yield delay(1000)
        yield put(
          updateQcReapproveSuccess(qcRequestData, "Record Deleted Successfully")
        )
        // yield call(redirect)
      } catch (error) {
        yield put(
          updateQcReapproveError(
            (error && error.response && error.response.message) ||
              "Delete Record Failed"
          )
        )
      } finally {
        // yield call(setSubmitting, false)
      }
    }
  }
}

//Quotation details saga
function* createQuotationListSaga() {
  while (true) {
    // eslint-disable-line no-constant-condition
    const { create } = yield race({
      create: take(UPDATE_QUOTATION_LIST),
    })

    console.log("FFFF &&& Lokesh Func ->", create)

    const { quotationList } = create || {}
    if (create) {
      // yield call(setSubmitting, true)

      try {
        yield call(updateQuotationList, quotationList)
        // yield delay(1000)
        yield put(
          updateQuotationListSuccess(
            quotationList,
            "Record Updated Successfully"
          )
        )
        // yield call(redirect)
      } catch (error) {
        yield put(
          updateQuotationListError(
            (error && error.response && error.response.message) ||
              "Update Record Failed"
          )
        )
      } finally {
        // yield call(setSubmitting, false)
      }
    }
  }
}

function* loadQuotationListSaga() {
  while (true) {
    // eslint-disable-line no-constant-condition
    const load = yield race({
      explicitLoad: take(LOAD_QUOTATION_LIST),
    })

    const { explicitLoad } = load

    const { id } = explicitLoad || {}
    yield put(loadQuotationListAction(explicitLoad.id)) // Calling Dropdown API's

    if (explicitLoad) {
      try {
        const result = yield call(loadQuotationList, id)

        if (result) {
          yield put(loadQuotationListSuccess(result.data))
        } else {
          yield put(loadQuotationListError("Fetch Records Failed"))
        }
      } catch (error) {
        yield put(
          loadQuotationListError(
            (error && error.response && error.response.message) ||
              "Fetch Records Failed"
          )
        )
      }
    }
  }
}

//Quotation review
function* loadRecordQuotationPreviewSaga() {
  while (true) {
    // eslint-disable-line no-constant-condition
    const load = yield race({
      explicitLoad: take(LOAD_QUOTATION_PREVIEW),
    })

    const { explicitLoad } = load

    const { id } = explicitLoad || {}
    yield put(loadQuotationPreview(explicitLoad.id)) // Calling Dropdown API's

    if (explicitLoad) {
      try {
        const result = yield call(loadQuotationPreviewDetails, id)

        if (result) {
          yield put(loadQuotationPreviewSuccess(result.data))
        } else {
          yield put(loadQuotationPreviewError("Fetch Records Failed"))
        }
      } catch (error) {
        yield put(
          loadQuotationPreviewError(
            (error && error.response && error.response.message) ||
              "Fetch Records Failed"
          )
        )
      }
    }
  }
}
//Quotation update preview saga
function* updateQuotationPreviewSaga() {
  while (true) {
    // eslint-disable-line no-constant-condition
    const { update } = yield race({
      update: take(UPDATE_QUOTATION_PREVIEW),
    })

    console.log("FFFF &&& Lokesh Func ->", update)

    const { quotationPreview } = update || {}
    if (update) {
      try {
        yield call(updateQuotationPreviewDetails, quotationPreview)
        // yield delay(1000)
        yield put(
          updateQuotationPreviewSuccess(
            quotationPreview,
            "Record Updated Successfully"
          )
        )
        // yield call(redirect)
      } catch (error) {
        yield put(
          updateQuotationPreviewError(
            (error && error.response && error.response.message) ||
              "Update Record Failed"
          )
        )
      } finally {
        // yield call(setSubmitting, false)
      }
    }
  }
}

//Discount Preview

function* updateDiscountPreviewSaga() {
  while (true) {
    // eslint-disable-line no-constant-condition
    const { update } = yield race({
      update: take(UPDATE_DISCOUNT_PREVIEW),
    })
    const { discountPreview } = update || {}
    if (update) {
      try {
        yield call(updateDiscountPreviewDetails, discountPreview)
        // yield delay(1000)
        yield put(
          updateDiscountPreviewSuccess(
            discountPreview,
            "Record Deleted Successfully"
          )
        )
        // yield call(redirect)
      } catch (error) {
        yield put(
          updateDiscountPreviewError(
            (error && error.response && error.response.message) ||
              "Delete Record Failed"
          )
        )
      } finally {
        // yield call(setSubmitting, false)
      }
    }
  }
}

function* loadRecordsMetaDataSaga() {
  while (true) {
    // eslint-disable-line no-constant-condition
    yield race({
      metaData: take(LOAD_RECORDS_META_DATA),
    })

    try {
      const eventType = yield call(loadRecordsMetaData, "event_type", "post")
      const event = yield call(loadRecordsMetaData, "event", "post")

      let recordsMetaData = {
        eventTypeOptions:
          (eventType &&
            eventType.data &&
            eventType.data.length > 0 &&
            eventType.data
              .filter((_) => _.status === 1)
              .map((c) =>
                Object.assign(
                  {},
                  {
                    label: c.eventType,
                    value: c._id,
                    shortCode: c.shortCode,
                    //  companyId: c.companyId
                  }
                )
              )) ||
          [],
        eventOptions:
          (event &&
            event.data &&
            event.data.length > 0 &&
            event.data
              .filter((_) => _.status === 1)
              .map((c) =>
                Object.assign(
                  {},
                  {
                    label: c.eventName,
                    value: c._id,
                    eventNo: c.eventNo,
                    eventCode: c.eventCode,
                    //  companyId: c.companyId
                  }
                )
              )) ||
          [],
      }

      console.log("recordsMetaData-->", recordsMetaData)

      yield put(loadRecordsMetaDataSuccess(recordsMetaData))
    } catch (error) {
      yield put(
        loadRecordsMetaDataError(
          (error && error.response && error.response.message) ||
            "Fetch Dropdown Records Failed"
        )
      )
    }
  }
}

function* loadDeliverableRecordsMetaDataSaga() {
  while (true) {
    // eslint-disable-line no-constant-condition
    yield race({
      metaData: take(LOAD_DELIVERABLES_RECORDS_META_DATA),
    })

    try {
      const deliverable = yield call(
        loadDeliverableRecordsMetaDataDetails,
        "deliverable",
        "post"
      )
      const product = yield call(
        loadDeliverableRecordsMetaDataDetails,
        "product",
        "post"
      )
      const subProduct = yield call(
        loadDeliverableRecordsMetaDataDetails,
        "sub_product",
        "post"
      )
      const deliveryMode = yield call(
        loadDeliverableRecordsMetaDataDetails,
        "delivery_mode",
        "post"
      )

      let recordsMetaData = {
        deliverablesOptions:
          (deliverable &&
            deliverable.data &&
            deliverable.data.length > 0 &&
            deliverable.data
              .filter((_) => _.status === 1)
              .map((c) =>
                Object.assign(
                  {},
                  {
                    label: c.deliverableName,
                    value: c._id,
                  }
                )
              )) ||
          [],
        deliveryModeOptions:
          (deliveryMode &&
            deliveryMode.data &&
            deliveryMode.data.length > 0 &&
            deliveryMode.data
              .filter((_) => _.status === 1)
              .map((c) =>
                Object.assign(
                  {},
                  {
                    label: c.deliveryMode,
                    value: c._id,
                  }
                )
              )) ||
          [],
        productOptions:
          (product &&
            product.data &&
            product.data.length > 0 &&
            product.data
              .filter((_) => _.status === 1)
              .map((c) =>
                Object.assign(
                  {},
                  {
                    label: c.productName,
                    value: c._id,
                    count: c.count,
                    sheet: c.sheet,
                    shutNumber: c.shutNumber,
                    price: c.price,
                    length: c.length,
                    productQuantity: c.productQuantity,
                    deliverable: c.deliverable,
                    defaultQuantity: c.defaultQuantity,
                    subProductId: c.subProductId,
                  }
                )
              )) ||
          [],
        subProductOptions:
          (subProduct &&
            subProduct.data &&
            subProduct.data.length > 0 &&
            subProduct.data
              .filter((_) => _.status === 1)
              .map((c) =>
                Object.assign(
                  {},
                  {
                    label: c.subProductName,
                    value: c._id,
                  }
                )
              )) ||
          [],
      }

      console.log("recordsMetaData-->", recordsMetaData)

      yield put(loadDeliverableRecordsMetaDataSuccess(recordsMetaData))
    } catch (error) {
      yield put(
        loadDeliverableRecordsMetaDataError(
          (error && error.response && error.response.message) ||
            "Fetch Dropdown Records Failed"
        )
      )
    }
  }
}
function* loadInstructionsRecordsMetaDataSaga() {
  while (true) {
    // eslint-disable-line no-constant-condition
    yield race({
      metaData: take(LOAD_INSTRUCTIONS_RECORDS_META_DATA),
    })

    try {
      const department = yield call(
        loadInstructionsRecordsMetaDataDetails,
        "department",
        "post"
      )
      const team = yield call(
        loadInstructionsRecordsMetaDataDetails,
        "team",
        "post"
      )

      let recordsMetaData = {
        departmentOptions:
          (department &&
            department.data &&
            department.data.length > 0 &&
            department.data
              .filter((_) => _.status === 1)
              .map((c) =>
                Object.assign({}, { label: c.name, value: c._id })
              )) ||
          (department &&
            department.length > 0 &&
            department.map((c) =>
              Object.assign({}, { label: c.name, value: c._id })
            )) ||
          [],
        teamOptions:
          (team &&
            team.data &&
            team.data.length > 0 &&
            team.data
              .filter((_) => _.status === 1)
              .map((c) =>
                Object.assign({}, { label: c.team, value: c._id })
              )) ||
          (team &&
            team.length > 0 &&
            team.map((c) =>
              Object.assign({}, { label: c.team, value: c._id })
            )) ||
          [],
      }

      console.log("recordsMetaData-->", recordsMetaData)

      yield put(loadInstructionsRecordsMetaDataSuccess(recordsMetaData))
    } catch (error) {
      yield put(
        loadInstructionsRecordsMetaDataError(
          (error && error.response && error.response.message) ||
            "Fetch Dropdown Records Failed"
        )
      )
    }
  }
}

function* loadQuotationHistoryDetailsSaga() {
  while (true) {
    const { create } = yield race({
      create: take(LOAD_QUOTATION_HISTORY_DETAILS),
    })
    const { record } = create || {}

    console.log("create-> ", create)

    if (create) {
      try {
        const historyQuatationData = yield call(
          loadQuotationHistoryDetails,
          record
        )
        let recordsHistoryQuatationData =
          historyQuatationData &&
          historyQuatationData.data &&
          historyQuatationData.data.length > 0
            ? historyQuatationData.data
            : []
        yield put(
          loadQuotationHistoryDetailsSuccess(recordsHistoryQuatationData)
        )
      } catch (error) {
        yield put(
          loadQuotationHistoryDetailsError(
            (error && error.response && error.response.message) ||
              "Fetch Dropdown Records Failed"
          )
        )
      }
    }
  }
}

function* loadQCLayoutMasterDetailsSaga() {
  while (true) {
    const { create } = yield race({
      create: take(LOAD_QC_LAYOUT_MASTER),
    })
    const { payloadLayoutMaster } = create || {}

    yield put(loadQCLayoutMasterAction(create)) // Calling Dropdown API's

    if (create) {
      try {
        const historyQuatationData = yield call(
          loadQCLayoutMaster,
          payloadLayoutMaster
        )
        if (historyQuatationData) {
          yield put(loadQCLayoutMasterSuccess(historyQuatationData.data))
        } else {
          yield put(loadQCLayoutMasterError("Fetch Records Failed"))
        }
      } catch (error) {
        yield put(
          loadQCLayoutMasterError(
            (error && error.response && error.response.message) ||
              "Fetch Records Failed"
          )
        )
      }
    }
  }
}

//Segment Function
function* loadQCLayoutSegmentDetailsSaga() {
  while (true) {
    // eslint-disable-line no-constant-condition
    const load = yield race({
      explicitLoad: take(LOAD_QC_LAYOUT_SEGMENT),
    })

    const { explicitLoad } = load

    // const { id } = explicitLoad || {}
    yield put(loadQCLayoutSegmentAction(explicitLoad)) // Calling Dropdown API's

    if (explicitLoad) {
      try {
        const result = yield call(loadQCLayoutSegment)

        if (result) {
          yield put(loadQCLayoutSegmentSuccess(result.data))
        } else {
          yield put(loadQCLayoutSegmentError("Fetch Records Failed"))
        }
      } catch (error) {
        yield put(
          loadQCLayoutSegmentError(
            (error && error.response && error.response.message) ||
              "Fetch Records Failed"
          )
        )
      }
    }
  }
}

function* addSegmentPreviewSaga() {
  while (true) {
    // eslint-disable-line no-constant-condition
    const { create } = yield race({
      create: take(ADD_SEGMENT_PREVIEW),
    })
    const { segmentPreview } = create || {}

    if (create) {
      console.log("records", segmentPreview)
      try {
        yield call(addSegmentPreviewDetails, segmentPreview)

        var successVal = addSegmentPreviewSuccess(
          segmentPreview,
          "Record Created Successfully"
        )

        yield put(successVal)
      } catch (error) {
        yield put(
          addSegmentPreviewError(
            (error && error.response && error.response.message) ||
              "Create Record Failed"
          )
        )
      } finally {
        // yield call(setSubmitting, false)
      }
    }
  }
}

function* addTeamSaga() {
  while (true) {
    // eslint-disable-line no-constant-condition
    const { create } = yield race({
      create: take(ADD_TEAM_ASSIGN),
    })
    const { team_details } = create || {}
    if (create) {
      try {
        yield call(addTeamAPI, team_details)
        yield put(addTeamAssignSuccess(team_details))
      } catch (error) {
        yield put(
          addTeamAssignError(
            (error && error.response && error.response.message) ||
              "Create Record Failed"
          )
        )
      }
    }
  }
}

function* addProductSaga() {
  while (true) {
    // eslint-disable-line no-constant-condition
    const { add } = yield race({
      add: take(ADD_PRODUCT_ASSIGN),
    })
    const { product_details } = add || {}
    if (add) {
      try {
        yield call(addProductAPI, product_details)
        yield put(
          addProductAssignSuccess(
            product_details,
            "Record Updated Successfully"
          )
        )
      } catch (error) {
        yield put(
          addProductAssignError(
            (error && error.response && error.response.message) ||
              "Updated Record Failed"
          )
        )
      } finally {
        // yield call(setSubmitting, false)
      }
    }
  }
}

function* updateCrmDeliverSaga() {
  while (true) {
    // eslint-disable-line no-constant-condition
    const { add } = yield race({
      add: take(UPDATE_CRM_DELIVER),
    })
    const { crmDeliver } = add || {}
    if (add) {
      try {
        yield call(updateCrmDeliverAPI, crmDeliver)
        yield put(
          updateCrmDeliverSuccess(crmDeliver, "Record Updated Successfully")
        )
      } catch (error) {
        yield put(
          updateCrmDeliverError(
            (error && error.response && error.response.message) ||
              "Updated Record Failed"
          )
        )
      } finally {
        // yield call(setSubmitting, false)
      }
    }
  }
}

function* loadDeliverableEmployeeSaga() {
  while (true) {
    // eslint-disable-line no-constant-condition
    const load = yield race({
      explicitLoad: take(LOAD_DELIVERABLE_EMPLOYEE),
    })

    const { explicitLoad } = load

    // const { id } = explicitLoad || {}
    yield put(loadDeliverableEmployee(explicitLoad)) // Calling Dropdown API's

    if (explicitLoad) {
      try {
        const result = yield call(loadDeliverableEmployeeList)

        if (result) {
          yield put(loadDeliverableEmployeeSuccess(result.data))
        } else {
          yield put(loadDeliverableEmployeeError("Fetch Records Failed"))
        }
      } catch (error) {
        yield put(
          loadDeliverableEmployeeError(
            (error && error.response && error.response.message) ||
              "Fetch Records Failed"
          )
        )
      }
    }
  }
}

function* updateProcessSaga() {
  while (true) {
    // eslint-disable-line no-constant-condition
    const { add } = yield race({
      add: take(UPDATE_PROCESS),
    })
    const { submitStatus } = add || {}
    if (add) {
      try {
        yield call(updateProcessAPI, submitStatus)
        yield put(
          updateProcessSuccess(submitStatus, "Record Updated Successfully")
        )
      } catch (error) {
        yield put(
          updateProcessError(
            (error && error.response && error.response.message) ||
              "Updated Record Failed"
          )
        )
      } finally {
        // yield call(setSubmitting, false)
      }
    }
  }
}

function* addCrmDetailsSaga() {
  while (true) {
    // eslint-disable-line no-constant-condition
    const { add } = yield race({
      add: take(ADD_CRM),
    })
    const { crm_details } = add || {}
    if (add) {
      try {
        yield call(addCrmAssignApi, crm_details)
        yield put(addCrmAssignSuccess("CRM Assigned Successfully"))
      } catch (error) {
        yield put(
          addCrmAssignError(
            (error && error.response && error.response.message) ||
              "CRM Assigned Failed"
          )
        )
      } finally {
        // yield call(setSubmitting, false)
      }
    }
  }
}

function* loadProcessStatusSaga() {
  while (true) {
    // eslint-disable-line no-constant-condition
    const load = yield race({
      explicitLoad: take(LOAD_PROCESS_STATUS),
    })

    const { explicitLoad } = load

    // const { id } = explicitLoad || {}
    yield put(loadProcessStatus(explicitLoad)) // Calling Dropdown API's

    if (explicitLoad) {
      try {
        const result = yield call(loadProcessStatusApi)

        if (result) {
          yield put(loadProcessStatusSuccess(result.data))
        } else {
          yield put(loadProcessStatusError("Fetch Records Failed"))
        }
      } catch (error) {
        yield put(
          loadProcessStatusError(
            (error && error.response && error.response.message) ||
              "Fetch Records Failed"
          )
        )
      }
    }
  }
}
export default function* recordsSaga() {
  yield all([
    loadRecordsMetaDataSaga(),
    loadDeliverableRecordsMetaDataSaga(),
    loadInstructionsRecordsMetaDataSaga(),
    loadRecordQuotationDetailsSaga(),
    createQuotationRecordSaga(),
    editQuotationRecordSaga(),
    deleteQuotationRecordSaga(),
    loadDeliverableDetailsSaga(),
    createDeliverableSaga(),
    editDeliverableSaga(),
    deleteDeliverableSaga(),

    updateExpiryDateSaga(),

    loadValueInsertSaga(),
    createValueInsertaga(),
    editValueInsertSaga(),
    deleteValueInsertSaga(),

    loadInstructionsSaga(),
    createInstructionSaga(),
    editInstructionsSaga(),
    deleteInstructionsSaga(),

    loadPhotographySaga(),
    createPhotographySaga(),
    editPhotographySaga(),
    deletePhotographySaga(),
    loadServiceDetailsSaga(),
    loadServiceAccountSaga(),
    loadSalesApprovalSaga(),

    approvalRequestSaga(),
    updateReapprovalQcSaga(),

    loadEmployeeSaga(),
    loadQcHistorySaga(),
    loadQuotationHistoryDetailsSaga(),
    createQuotationListSaga(),
    loadQuotationListSaga(),
    loadQCLayoutMasterDetailsSaga(),
    loadQCLayoutSegmentDetailsSaga(),
    loadRecordQuotationPreviewSaga(),
    updateQuotationPreviewSaga(),

    addSegmentPreviewSaga(),
    addProductSaga(),

    addTeamSaga(),
    updateCrmDeliverSaga(),
    loadECDeliverableDetailsSaga(),
    loadDeliverableEmployeeSaga(),
    updateDiscountPreviewSaga(),

    updateProcessSaga(),
    addCrmDetailsSaga(),
    loadProcessStatusSaga(),
  ])
}
